import api from '@/apis/di/accountCategoryAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('accountCategory', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_account_category',
    field: {
      key: 'account_category_id',
      code: 'account_category_code',
      name: 'account_category_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
